import { Component } from '@angular/core';
import { ICellRenderer } from 'ag-grid-community';
import { OrderGridClickAndCollectComponent } from '../order-grid-click-and-collect/order-grid-click-and-collect.component';
import { ORDER_LINE_STATUS } from '@pos-app/data';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-action-header',
    template: `
    <div>
      <ng-container *ngIf="isHandPackage()" >
        <span [title]="'Mark as all items collected'" (click)="sellOrderAllItem()">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
            <path
              d="M600-800H360v280h240v-280Zm200 0H680v280h120v-280ZM575-440H320v240h222q21 0 40.5-7t35.5-21l166-137q-8-8-18-12t-21-6q-17-3-33
            1t-30 15l-108 87H400v-80h146l44-36q5-3 7.5-8t2.5-11q0-10-7.5-17.5T575-440Zm-335 0h-80v280h80v-280Zm40 0v-360q0-33 23.5-56.5T360-880h440q33
            0 56.5 23.5T880-800v280q0 33-23.5 56.5T800-440H280ZM240-80h-80q-33 0-56.5-23.5T80-160v-280q0-33 23.5-56.5T160-520h415q85 0 164 29t127
            98l27 41-223 186q-27 23-60 34.5T542-120H309q-11 18-29 29t-40 11Z"
            />
          </svg>
          <span class="pr-1"></span>
        </span>
      </ng-container>
    </div>
  `,
    styles: [
        `
      .btn {
        line-height: 0.5;
      }
      .dispatched {
        color: green;
      }
    `,
    ],
    imports: [NgIf]
})
export class ClickAndCollectOrderGridActionHeaderComponent implements ICellRenderer {
  public params: any;
  public parentComponent: OrderGridClickAndCollectComponent;

  //For select and de-select of orders
  public isOrdersSelect: boolean = false;

  agInit(params: any): void {
    this.params = params;
    this.parentComponent = this.params.context.componentParent;
  }

  public isHandPackage(): boolean {
    return this.parentComponent.orderHeader?.jobRequestOrderStatus === 40 || this.parentComponent.orderHeader?.jobRequestOrderStatus === 50;
  }

  public sellOrderAllItem(): void {
    return this.parentComponent.dispatchAllItems(ORDER_LINE_STATUS.selling);
  }

  public refresh(): boolean {
    return false;
  }
}

